import React from 'react';
import {
    Grid,
    TextField,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Box
} from '@mui/material';
import { MapPin } from 'lucide-react';
import { StepProps } from './TypeCadEscriComponents';
import { arrayUf } from '../../../data/dataUf';
import { cep } from '../../../components/Inputs/masks';


const STATES = arrayUf.map(i => i.value);

const AddressInfoStep: React.FC<StepProps> = ({ formik, activeStep }) => {
    if (activeStep !== 2) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="endereco_escritorio"
                        name="endereco_escritorio"
                        label="Endereço"
                        value={formik.values.endereco_escritorio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.endereco_escritorio && Boolean(formik.errors.endereco_escritorio)}
                        helperText={formik.touched.endereco_escritorio && formik.errors.endereco_escritorio}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <MapPin size={20} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <TextField
                        fullWidth
                        id="numero_escritorio"
                        name="numero_escritorio"
                        label="N°"
                        value={formik.values.numero_escritorio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.numero_escritorio && Boolean(formik.errors.numero_escritorio)}
                        helperText={formik.touched.numero_escritorio && formik.errors.numero_escritorio}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        fullWidth
                        id="bairro_escritorio"
                        name="bairro_escritorio"
                        label="Bairro"
                        value={formik.values.bairro_escritorio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.bairro_escritorio && Boolean(formik.errors.bairro_escritorio)}
                        helperText={formik.touched.bairro_escritorio && formik.errors.bairro_escritorio}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        id="complemento_escritorio"
                        name="complemento_escritorio"
                        label="Complemento"
                        value={formik.values.complemento_escritorio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.complemento_escritorio && Boolean(formik.errors.complemento_escritorio)}
                        helperText={formik.touched.complemento_escritorio && formik.errors.complemento_escritorio}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        fullWidth
                        id="cep_escritorio"
                        name="cep_escritorio"
                        label="CEP"
                        value={formik.values.cep_escritorio}
                        onChange={e => formik.setFieldValue('cep_escritorio', cep(e.target.value))}
                        onBlur={formik.handleBlur}
                        error={formik.touched.cep_escritorio && Boolean(formik.errors.cep_escritorio)}
                        helperText={formik.touched.cep_escritorio && formik.errors.cep_escritorio}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <FormControl
                        fullWidth
                        error={formik.touched.uf_escritorio && Boolean(formik.errors.uf_escritorio)}
                    >
                        <InputLabel id="state-label">UF</InputLabel>
                        <Select
                            labelId="state-label"
                            id="uf_escritorio"
                            name="uf_escritorio"
                            value={formik.values.uf_escritorio}
                            label="UF"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        >
                            {STATES.map((state) => (
                                <MenuItem key={state} value={state}>
                                    {state}
                                </MenuItem>
                            ))}
                        </Select>
                        {formik.touched.uf_escritorio && formik.errors.uf_escritorio && (
                            <FormHelperText>{formik.errors.uf_escritorio}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        id="cidade_escritorio"
                        name="cidade_escritorio"
                        label="Cidade"
                        value={formik.values.cidade_escritorio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.cidade_escritorio && Boolean(formik.errors.cidade_escritorio)}
                        helperText={formik.touched.cidade_escritorio && formik.errors.cidade_escritorio}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddressInfoStep;